import { Link } from 'react-router-dom';
import '../styles/Education.css';

export default function Education() {
  const educationData = {
    current: {
      school: "First Asia Institute of Technology and Humanities (FAITH Colleges)",
      program: "Bachelor of Science in Computer Engineering",
      yearLevel: "3rd Year",
      period: "2022 – Present",
      location: "Tanauan City, Batangas, Philippines",
      focus: "Software Development & Embedded Systems",
      coursework: [
        "Data Structures & Algorithms",
        "Embedded Systems",
        "Object Oriented Programming",
        "Digital IC Design",
        "Logic Circuits and Design",
      ],
      specialization: [
        "Embedded Systems & IoT",
        "Artificial Intelligence",
      ],
    },

    previous: [
      {
        school: "Greenville Academy of Sta. Clara",
        program: "Senior High School – STEM Strand",
        period: "2020 – 2022",
        location: "Sta. Clara, Sto. Tomas, Batangas",
        honors: "With Honors",
      },
      {
        program: "Junior High School",
        school: "Greenville Academy of Sta. Clara",
        location: "Sta. Clara, Sto. Tomas, Batangas", 
        period: "2017 – 2020",
      },
      {
        program: "Elementary",
        school: "The Golden Child Literacy Place",
        location: "San Felix Sto. Tomas, Batangas", 
        period: "2011 – 2017",
      },
    ],
  };

  return (
    <div className="edu-root">
      <div className="edu-bg" style={{ backgroundImage: `url('/bg.png')` }} />

      {/* ── Top bar ── */}
      <nav className="edu-topbar">
        <Link to="/" className="edu-logo">D.Malipol</Link>
        <Link to="/" className="edu-back">← Back to Home</Link>
      </nav>

      <div className="edu-wrapper">

        {/* ── Page header ── */}
        <div className="edu-header">
          <p className="edu-section-label">◆ Education</p>
          <h1 className="edu-page-title">My <span className="accent">Education</span></h1>
          <p className="edu-page-subtitle">My academic journey and educational background.</p>
        </div>

        {/* ── Current School ── */}
        <div className="edu-current-card">
          <div className="edu-current-badge">Currently Enrolled</div>

          <div className="edu-current-top">
            <div className="edu-school-icon">🎓</div>
            <div>
              <h2 className="edu-school-name">{educationData.current.school}</h2>
              <p className="edu-program">{educationData.current.program}</p>
              <div className="edu-meta-row">
                <span className="edu-meta-item">📅 {educationData.current.period}</span>
                <span className="edu-meta-item">📍 {educationData.current.location}</span>
                <span className="edu-meta-item">🏫 {educationData.current.yearLevel}</span>
              </div>
            </div>
          </div>

          <div className="edu-current-body">

            <div className="edu-info-card">
              <p className="edu-info-title">🎯 Academic Focus</p>
              <p className="edu-info-text">{educationData.current.focus}</p>
            </div>

            <div className="edu-info-card">
              <p className="edu-info-title">📚 Relevant Coursework</p>
              <div className="edu-coursework-grid">
                {educationData.current.coursework.map((course, i) => (
                  <div className="edu-course-tag" key={i}>{course}</div>
                ))}
              </div>
            </div>

            <div className="edu-info-card">
              <p className="edu-info-title">💡 Specialization Interests</p>
              <div className="edu-spec-list">
                {educationData.current.specialization.map((spec, i) => (
                  <div className="edu-spec-item" key={i}>
                    <span className="edu-spec-dot" />
                    {spec}
                  </div>
                ))}
              </div>
            </div>

          </div>
        </div>

        {/* ── Previous Schools ── */}
        <div className="edu-previous-section">
          <h2 className="edu-prev-heading">Previous Schools</h2>

          {educationData.previous.map((school, i) => (
            <div className="edu-prev-card" key={i}>
              <div className="edu-prev-left">
                <div className="edu-prev-icon">🏫</div>
                <div className="edu-prev-period">{school.period}</div>
              </div>
              <div className="edu-prev-right">
                <div className="edu-prev-top">
                  <div>
                    <h3 className="edu-prev-school">{school.school}</h3>
                    <p className="edu-prev-program">{school.program}</p>
                    <p className="edu-prev-location">📍 {school.location}</p>
                  </div>
                  {school.honors && (
                    <span className="edu-prev-badge">{school.honors}</span>
                  )}
                </div>
                {school.details && (
                  <p className="edu-prev-details">{school.details}</p>
                )}
              </div>
            </div>
          ))}
        </div>

        {/* ── CTA ── */}
        <div className="edu-cta">
          <Link to="/resume" className="btn btn-primary">📄 View Full Resume</Link>
          <Link to="/achievements" className="btn btn-secondary">🏆 View Achievements</Link>
        </div>

      </div>
    </div>
  );
}